<template>
  <div class="container">
    <h2 class="title">{{ title }}</h2>
    <div class="content" v-if="item && item.periodicalIntro" v-html="item.periodicalIntro"></div>
    <div class="content no-content" v-else>
      <img src="@/assets/img/qietu/nodata.png" alt="" />
      <div>暂无数据</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  // box-shadow: 0px 7px 15px 1px rgba(22, 26, 100, 0.1);
  box-sizing: border-box;
  overflow: hidden;
  border: 1px solid #A3CBE7;
  border-radius: 10px;
  .title {
    height: 68px;
    padding: 26px 0 0 28px;
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    border-bottom: 1px solid #e5e5e5;
  }
  .content {
    padding: 30px;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    color: #333333;
    &::v-deep p {
      margin-bottom: 10px;
    }
  }
  .no-content {
    text-align: center;
    img {
      margin: 0 auto 10px;
      width: 285px;
      height: 240px;
    }
  }
}
</style>
